import { call } from "redux-saga/effects";
import { API_URL, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

// New saga for available time slots
export function* getAvailableTimeSlots(action: any): any {
  const { member_id } = action.payload || {};
  let url = API_URL.INTERVIEW.GET_AVAILABLE_TIME_SLOTS;
  if (member_id) {
    url += `?member_id=${member_id}`;
  }
  yield call(sagaFunction, action, CallApi.GET, url, {}, true);
}

export function* addAvailability(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.INTERVIEW.ADD_AVAILABILITY, action.payload, true);
}

export function* addUnavailability(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.INTERVIEW.ADD_UNAVAILABILITY, action.payload, true);
}

export function* deleteUnavailability(action: any): any {
  yield call(sagaFunction, action, CallApi.DELETE, API_URL.INTERVIEW.DELETE_UNAVAILABILITY, action.payload, true);
}

export function* getSchedule(action: any): any {
  const { type, member_id, job_id, status } = action.payload || {};
  let url = API_URL.INTERVIEW.GET_SCHEDULE;
  const params: string[] = [];

  if (type) {
    params.push(`type=${type}`);
  }

  if (member_id) {
    params.push(`member_id=${member_id}`);
  }

  if (job_id) {
    params.push(`job_id=${job_id}`);
  }

  if (status) {
    params.push(`status=${status}`);
  }

  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  yield call(sagaFunction, action, CallApi.GET, url, {}, true);
}

export function* scheduleRequest(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.INTERVIEW.SCHEDULE_REQUEST, action.payload, true);
}

export function* scheduleRequestAI(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.INTERVIEW.SCHEDULE_REQUEST_AI, action.payload, true);
}

export function* getVideoCallData(action: any): any {
  const { interviewId } = action.payload || {};
  const url = `${API_URL.INTERVIEW.GET_VIDEO_CALL_DATA}/${interviewId}`;

  yield call(sagaFunction, action, CallApi.GET, url, {}, true);
}

export function* rescheduleOrCancel(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.INTERVIEW.RESCHEDULE_OR_CANCEL, action.payload, true);
}

export function* updateValidity(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.INTERVIEW.UPDATE_VALIDITY, action.payload, true);
}

export function* submitInterviewFeedback(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.INTERVIEW.SUBMIT_FEEDBACK, action.payload, true);
}

export function* getInterviewEvaluation(action: any): any {
  const { schedule_id } = action.payload || {};
  const url = `${API_URL.INTERVIEW.GET_EVALUATION}?schedule_id=${schedule_id}`;
  yield call(sagaFunction, action, CallApi.GET, url, {}, true);
}
